import { langdict } from '@/lang/langdict';

export const langKeyMap = {
  'en-US': 'enUs', // 英文
  // 'es-MX': 'esMx', // 墨西哥-西班牙语
  'id-ID': 'idId', // 印度尼西亚-印尼语
  'th-TH': 'thTh', // 泰语
  'zh-CN': 'zhCn', // 中文简体
  // 'zh-TW': 'zhTw', // 中文繁体
  // 'ja-JP': 'jaJp', // 日语
}
export const langKeyNameMap = {
  'en-US': 'enName', // 英文
  'es-MX': 'esMxName', // 墨西哥-西班牙语
  'id-ID': 'idIdName', // 印度尼西亚-印尼语
  'th-TH': 'thThName', // 泰语
  'zh-CN': 'name', // 中文简体
  'zh-TW': 'zhTwName', // 中文繁体
  'ja-JP': 'jaJpName', // 日语
  'ko-KR': 'koKrName', // 韩语
  'fr-FR': 'frFrName', // 法语
  'de-DE': 'deDeName', // 德语
  'pt-BR': 'ptBrName', // 葡萄牙语（巴西）
  'ru-RU': 'ruRuName', // 俄语
  'ar-SA': 'arSaName', // 阿拉伯语
  'vi-VN': 'viVnName', // 越南语
  'lo-LA': 'loLaName', // 老挝语
  'ar-AE': 'arAeName', // 阿拉伯语（阿联酋）
  'tr-TR': 'trTrName', // 土耳其语
}

// 优先获取浏览器语言
export const getPrimaryLanguage = () => {
  const lang = navigator.language || navigator.userLanguage || 'en';
  const prefix = lang.split('-')[0]; // 提取 "zh" from "zh-CN"
  let langKey = 'en-US'; // 没有时的默认
  for (let key in langKeyMap) {
    if (key.split('-')[0] === prefix) {
      langKey = key;
    }
  }
  if (import.meta.env.VITE_APP_PLATFORM_NAME === 'PLN Icon Plus' && langKey == 'zh-CN') { // 印尼项目只有英文、印尼文
    langKey = 'en-US';
  }
  console.log('浏览器语言', langKey);
  return langKey;
}

// 方便直接取值
export const reduceListToTree = (list, langKey) => {
  const language = langKey || sessionStorage.getItem('language') || getPrimaryLanguage() || import.meta.env.VITE_APP_LANGUAGE;

  const Lang = {}
  const currentLangKey = langKeyMap[language];
  if (Array.isArray(list)) {
    list.map(item => {
      if (item.classify) {
        if (!Lang[item.classify]) {
          Lang[item.classify] = {}
        }
        Lang[item.classify][item.textKey] = item[currentLangKey];
      } else {
        Lang[item.textKey] = item[currentLangKey];
      }
    })
  }
  return Lang;
}


export const getLanguage = (langKey) => {
  let langPack = localStorage.getItem('langPack') || '{}';
  let Lang = JSON.parse(langPack) || {};
  if (!Lang.option || langKey) { // 如果没有语言包或者传入了语言key，则从本地重新获取语言包
    Lang = reduceListToTree(langdict.data, langKey);
  }
  return Lang;
}
export const Lang = getLanguage();

// 传入文本播放声音
export const say = (text, lang = 'en-US', rate = 1, pitch = 1, volume = 1) => {
  const synth = window.speechSynthesis;
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.rate = rate; // 语速
  utterance.pitch = pitch; // 音调
  utterance.volume = volume; // 音量
  // utterance.lang = lang;
  synth.speak(utterance);
}

export const generateI18nOptoins = () => {
  const list = []
  const sortKeys = Object.keys(langKeyMap).sort()
  sortKeys.forEach((key) => {
    list.push({
      translateKey: key,
      i18nLanguage: key,
      i18nLabel: key,
      i18nValue: '',
      i18nField: 'name',
    })
  })
  return list;
}

export const i18nOptoins = generateI18nOptoins();
